module.exports = __webpack_public_path__ + "static/media/im.f6e8452c.svg";